/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetOrdersByDatesRequestDto } from '../models';
// @ts-ignore
import type { GetOrdersByDatesResponseDto } from '../models';
// @ts-ignore
import type { GetOrdersByStatusRequestDto } from '../models';
// @ts-ignore
import type { GetOrdersByStatusResponseDto } from '../models';
// @ts-ignore
import type { OrderInfoRequestDto } from '../models';
// @ts-ignore
import type { OrderInfoRequestWithUserIdDto } from '../models';
// @ts-ignore
import type { OrderPageableDto } from '../models';
// @ts-ignore
import type { OrdersInfoDto } from '../models';
// @ts-ignore
import type { PageableRequestDto } from '../models';
// @ts-ignore
import type { PageableRequestWithUserIdDto } from '../models';
/**
 * ORDERApi - axios parameter creator
 * @export
 */
export const ORDERApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение своих заказов
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetMyOrders: async (pageableRequestDto: PageableRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageableRequestDto' is not null or undefined
            assertParamExists('orderControllerGetMyOrders', 'pageableRequestDto', pageableRequestDto)
            const localVarPath = `/order/getMyOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageableRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение информации о своих заказах
         * @param {OrderInfoRequestDto} orderInfoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetMyOrdersInfo: async (orderInfoRequestDto: OrderInfoRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderInfoRequestDto' is not null or undefined
            assertParamExists('orderControllerGetMyOrdersInfo', 'orderInfoRequestDto', orderInfoRequestDto)
            const localVarPath = `/order/getMyOrdersInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderInfoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение заказов
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrders: async (pageableRequestDto: PageableRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageableRequestDto' is not null or undefined
            assertParamExists('orderControllerGetOrders', 'pageableRequestDto', pageableRequestDto)
            const localVarPath = `/order/getOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageableRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение статистики заказов по датам
         * @param {GetOrdersByDatesRequestDto} getOrdersByDatesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersByDates: async (getOrdersByDatesRequestDto: GetOrdersByDatesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getOrdersByDatesRequestDto' is not null or undefined
            assertParamExists('orderControllerGetOrdersByDates', 'getOrdersByDatesRequestDto', getOrdersByDatesRequestDto)
            const localVarPath = `/order/getOrdersByDates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrdersByDatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение статистики заказов по статусам
         * @param {GetOrdersByStatusRequestDto} getOrdersByStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersByStatus: async (getOrdersByStatusRequestDto: GetOrdersByStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getOrdersByStatusRequestDto' is not null or undefined
            assertParamExists('orderControllerGetOrdersByStatus', 'getOrdersByStatusRequestDto', getOrdersByStatusRequestDto)
            const localVarPath = `/order/getOrdersByStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrdersByStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение заказов по userId
         * @param {PageableRequestWithUserIdDto} pageableRequestWithUserIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersByUserId: async (pageableRequestWithUserIdDto: PageableRequestWithUserIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageableRequestWithUserIdDto' is not null or undefined
            assertParamExists('orderControllerGetOrdersByUserId', 'pageableRequestWithUserIdDto', pageableRequestWithUserIdDto)
            const localVarPath = `/order/getOrdersByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageableRequestWithUserIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение информации о заказах по userId
         * @param {OrderInfoRequestWithUserIdDto} orderInfoRequestWithUserIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersInfoByUserId: async (orderInfoRequestWithUserIdDto: OrderInfoRequestWithUserIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderInfoRequestWithUserIdDto' is not null or undefined
            assertParamExists('orderControllerGetOrdersInfoByUserId', 'orderInfoRequestWithUserIdDto', orderInfoRequestWithUserIdDto)
            const localVarPath = `/order/getOrdersInfoByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderInfoRequestWithUserIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ORDERApi - functional programming interface
 * @export
 */
export const ORDERApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ORDERApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение своих заказов
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetMyOrders(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderPageableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetMyOrders(pageableRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ORDERApi.orderControllerGetMyOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение информации о своих заказах
         * @param {OrderInfoRequestDto} orderInfoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetMyOrdersInfo(orderInfoRequestDto: OrderInfoRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetMyOrdersInfo(orderInfoRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ORDERApi.orderControllerGetMyOrdersInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение заказов
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetOrders(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderPageableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetOrders(pageableRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ORDERApi.orderControllerGetOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение статистики заказов по датам
         * @param {GetOrdersByDatesRequestDto} getOrdersByDatesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetOrdersByDates(getOrdersByDatesRequestDto: GetOrdersByDatesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrdersByDatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetOrdersByDates(getOrdersByDatesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ORDERApi.orderControllerGetOrdersByDates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение статистики заказов по статусам
         * @param {GetOrdersByStatusRequestDto} getOrdersByStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetOrdersByStatus(getOrdersByStatusRequestDto: GetOrdersByStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrdersByStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetOrdersByStatus(getOrdersByStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ORDERApi.orderControllerGetOrdersByStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение заказов по userId
         * @param {PageableRequestWithUserIdDto} pageableRequestWithUserIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetOrdersByUserId(pageableRequestWithUserIdDto: PageableRequestWithUserIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderPageableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetOrdersByUserId(pageableRequestWithUserIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ORDERApi.orderControllerGetOrdersByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение информации о заказах по userId
         * @param {OrderInfoRequestWithUserIdDto} orderInfoRequestWithUserIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetOrdersInfoByUserId(orderInfoRequestWithUserIdDto: OrderInfoRequestWithUserIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetOrdersInfoByUserId(orderInfoRequestWithUserIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ORDERApi.orderControllerGetOrdersInfoByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ORDERApi - factory interface
 * @export
 */
export const ORDERApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ORDERApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение своих заказов
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetMyOrders(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OrderPageableDto> {
            return localVarFp.orderControllerGetMyOrders(pageableRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение информации о своих заказах
         * @param {OrderInfoRequestDto} orderInfoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetMyOrdersInfo(orderInfoRequestDto: OrderInfoRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OrdersInfoDto> {
            return localVarFp.orderControllerGetMyOrdersInfo(orderInfoRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение заказов
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrders(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OrderPageableDto> {
            return localVarFp.orderControllerGetOrders(pageableRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение статистики заказов по датам
         * @param {GetOrdersByDatesRequestDto} getOrdersByDatesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersByDates(getOrdersByDatesRequestDto: GetOrdersByDatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GetOrdersByDatesResponseDto> {
            return localVarFp.orderControllerGetOrdersByDates(getOrdersByDatesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение статистики заказов по статусам
         * @param {GetOrdersByStatusRequestDto} getOrdersByStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersByStatus(getOrdersByStatusRequestDto: GetOrdersByStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GetOrdersByStatusResponseDto> {
            return localVarFp.orderControllerGetOrdersByStatus(getOrdersByStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение заказов по userId
         * @param {PageableRequestWithUserIdDto} pageableRequestWithUserIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersByUserId(pageableRequestWithUserIdDto: PageableRequestWithUserIdDto, options?: RawAxiosRequestConfig): AxiosPromise<OrderPageableDto> {
            return localVarFp.orderControllerGetOrdersByUserId(pageableRequestWithUserIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение информации о заказах по userId
         * @param {OrderInfoRequestWithUserIdDto} orderInfoRequestWithUserIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersInfoByUserId(orderInfoRequestWithUserIdDto: OrderInfoRequestWithUserIdDto, options?: RawAxiosRequestConfig): AxiosPromise<OrdersInfoDto> {
            return localVarFp.orderControllerGetOrdersInfoByUserId(orderInfoRequestWithUserIdDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ORDERApi - object-oriented interface
 * @export
 * @class ORDERApi
 * @extends {BaseAPI}
 */
export class ORDERApi extends BaseAPI {
    /**
     * 
     * @summary Получение своих заказов
     * @param {PageableRequestDto} pageableRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ORDERApi
     */
    public orderControllerGetMyOrders(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig) {
        return ORDERApiFp(this.configuration).orderControllerGetMyOrders(pageableRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение информации о своих заказах
     * @param {OrderInfoRequestDto} orderInfoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ORDERApi
     */
    public orderControllerGetMyOrdersInfo(orderInfoRequestDto: OrderInfoRequestDto, options?: RawAxiosRequestConfig) {
        return ORDERApiFp(this.configuration).orderControllerGetMyOrdersInfo(orderInfoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение заказов
     * @param {PageableRequestDto} pageableRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ORDERApi
     */
    public orderControllerGetOrders(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig) {
        return ORDERApiFp(this.configuration).orderControllerGetOrders(pageableRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение статистики заказов по датам
     * @param {GetOrdersByDatesRequestDto} getOrdersByDatesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ORDERApi
     */
    public orderControllerGetOrdersByDates(getOrdersByDatesRequestDto: GetOrdersByDatesRequestDto, options?: RawAxiosRequestConfig) {
        return ORDERApiFp(this.configuration).orderControllerGetOrdersByDates(getOrdersByDatesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение статистики заказов по статусам
     * @param {GetOrdersByStatusRequestDto} getOrdersByStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ORDERApi
     */
    public orderControllerGetOrdersByStatus(getOrdersByStatusRequestDto: GetOrdersByStatusRequestDto, options?: RawAxiosRequestConfig) {
        return ORDERApiFp(this.configuration).orderControllerGetOrdersByStatus(getOrdersByStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение заказов по userId
     * @param {PageableRequestWithUserIdDto} pageableRequestWithUserIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ORDERApi
     */
    public orderControllerGetOrdersByUserId(pageableRequestWithUserIdDto: PageableRequestWithUserIdDto, options?: RawAxiosRequestConfig) {
        return ORDERApiFp(this.configuration).orderControllerGetOrdersByUserId(pageableRequestWithUserIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение информации о заказах по userId
     * @param {OrderInfoRequestWithUserIdDto} orderInfoRequestWithUserIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ORDERApi
     */
    public orderControllerGetOrdersInfoByUserId(orderInfoRequestWithUserIdDto: OrderInfoRequestWithUserIdDto, options?: RawAxiosRequestConfig) {
        return ORDERApiFp(this.configuration).orderControllerGetOrdersInfoByUserId(orderInfoRequestWithUserIdDto, options).then((request) => request(this.axios, this.basePath));
    }
}

